import { AvailableTimeSlot } from "../Components/Api/ApiClient";
import { makeAutoObservable } from "mobx";

class DateAndTimeSlotStoreClass {
    public date: Date | null = null;
    //public timeSlot: TimeSlot | null = null;
    public timeSlot: AvailableTimeSlot | null = null;
    public availableTimeSlots: AvailableTimeSlot[] = [];

    public constructor() {
        makeAutoObservable(this);
    }

    public setDate = (date: Date | null) => {
        this.date = date;
    }

    public setTimeSlot = (timeSlot: AvailableTimeSlot | null) => {
        this.timeSlot = timeSlot;
    }

    public setAvailableTimeSlots = (availableTimeSlots: AvailableTimeSlot[]) => {
        this.availableTimeSlots = availableTimeSlots;
    }

}

export const DateAndTimeStore = new DateAndTimeSlotStoreClass();